'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIMPLE = exports.SIMPLE = 'SIMPLE';
var EMAIL = exports.EMAIL = 'EMAIL';
var CRM = exports.CRM = 'CRM';